module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/d1680a847046403c792a689d2572ff80.jpg";